import React from "react";

const NameStatusRegAndVote = ({nameStatusRegAndVote}) => {

    return (
        <>
            <span>{nameStatusRegAndVote}</span>
        </>
    )
}

export default NameStatusRegAndVote;